// @version V0.0.1 [Saturday - 20201017_201751] : init
/**
 * Instruction : just add require('./LoadAddon/loadFontAwesome') on app.js
 */

// Vue Font Awesome 5
import { library } from "@fortawesome/fontawesome-svg-core";

import {
    faAngleDoubleUp,
    faAngleDoubleRight,
    faSignInAlt,
    faUserPlus,
    faFan,
    faHome,
    faCode,
    faCog,
    faSignOutAlt,
    faSyncAlt,
    faPlus,
    faList,
    faFile,
    faTrashAlt,
    faEdit,
    faSort,
    faEye,
    faEyeSlash,
    faAngleUp,
    faAngleDown,
    faTimes,
    faQuestion,
    faEllipsisV,
    faCarAlt,
    faMotorcycle,
    faAddressBook,
    faAddressCard,
    faPaperclip,
    faFilter,
    faPhoneAlt,
    faClipboard,
    faGlobe,
    faEnvelope, faUsers, faShieldAlt, faBars, faShoppingCart, faAngleLeft, faAngleRight, faTruckMoving, faCheckSquare, faCaretRight, faPlusCircle, faMinusCircle, faSave, faDotCircle, faBan
} from '@fortawesome/free-solid-svg-icons'

// brand
import {
    faWhatsapp, faFacebook
} from '@fortawesome/free-brands-svg-icons'

// Regular
// import {  } from "@fortawesome/free-regular-svg-icons";

// Custom Asahi
import { faMyCarIcon, faSupplierAsahi, faAssetAsahi, faCustomerAsahi, faGreetingAsahi, faLoginAsahi, faPurchaseAsahi, faReportAsahi, faSaleAsahi, faStockAsahi, faTransactionAsahi, faRegisterAsahi } from './../font-awesome-customs/index'

library.add(
    faAssetAsahi,
    faCustomerAsahi,
    faGreetingAsahi,
    faLoginAsahi,
    faPurchaseAsahi,
    faReportAsahi,
    faSaleAsahi,
    faStockAsahi,
    faTransactionAsahi,
    faMyCarIcon,
    faSupplierAsahi,
    faRegisterAsahi,
    faAngleDoubleUp,
    faAngleDoubleRight,
    faSignInAlt,
    faUserPlus,
    faFan,
    faHome,
    faCode,
    faCog,
    faSignOutAlt,
    faSyncAlt,
    faPlus,
    faList,
    faFile,
    faTrashAlt,
    faEdit,
    faSort,
    faEye,
    faEyeSlash,
    faAngleUp,
    faAngleDown,
    faTimes,
    faQuestion,
    faEllipsisV,
    faCarAlt,
    faMotorcycle,
    faAddressBook,
    faAddressCard,
    faPaperclip,
    faFilter,
    faPhoneAlt,
    faClipboard,
    faWhatsapp,
    faGlobe,
    faFacebook,
    faEnvelope,
    faUsers,
    faShieldAlt,
    faBars,
    faShoppingCart,
    faAngleLeft,
    faAngleRight,
    faTruckMoving,
    faCheckSquare,
    faSignInAlt,
    faCaretRight,
    faPlusCircle,
    faMinusCircle,
    faSave,
    faDotCircle,
    faBan
)


// Initialize component
import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome'

import Vue from "vue"

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
